// extracted by mini-css-extract-plugin
module.exports = {"container":"page-wrapper_container__LYvly","fullScreen":"page-wrapper_fullScreen__V9uEt"};